export const en = {
  'copy.selected': 'Selected:',
  'copy.socialCaption':
    'AI scans social media for sentiment, influence patterns, and behavioral red flags.',
  'copy.countryCaption':
    'AI analyzes regulatory stability, corruption indices, and money-laundering risks by country.',
  'copy.mediaCaption':
    'AI searches global news and publications for negative mentions, allegations, or legal actions.',
  'copy.politicalCaption':
    'AI identifies politically exposed persons and their direct or indirect affiliations.',
  'copy.watchlistCaption':
    'AI cross-references international sanctions, enforcement lists, and banned entities.',
  'copy.heroDescription':
    '. Automated data collection, detect risk signals and generate compliance report, all in one platform.',
  'copy.age': 'Age:',
  'copy.nationality': 'Nationality:',
  'copy.job': 'Job:',
  'copy.audience': ". It's a strong fit for",
  'copy.ownerActivation':
    '. You will be notified once the owner logs in and their account is activated.',
  'copy.officerActivation':
    ". The officer's account will be activated once they log in through the invitation email.",
  'copy.findingInstructions': '. Confirm or dismiss each finding with a rationale.',
  'copy.source': 'Source:',
  'copy.fatfGreyList': 'FATF grey list',
  'copy.ofacMatch': 'OFAC name match',
  'copy.interpolNotice': 'INTERPOL red notice',
  'copy.euSanctions': 'EU sanctions listed',
} as const;
export const fa: Record<keyof typeof en, string> = {
  'copy.selected': 'انتخاب‌شده:',
  'copy.socialCaption':
    'هوش مصنوعی واکنش‌ها، الگوهای اثرگذاری و نشانه‌های رفتاری مشکوک را در شبکه‌های اجتماعی بررسی می‌کند.',
  'copy.countryCaption': 'ثبات مقررات، شاخص‌های فساد و ریسک پول‌شویی هر کشور بررسی می‌شود.',
  'copy.mediaCaption':
    'اخبار و منابع جهانی برای یافتن گزارش‌های منفی، اتهام‌ها و پرونده‌های حقوقی جست‌وجو می‌شوند.',
  'copy.politicalCaption':
    'اشخاص دارای موقعیت سیاسی و ارتباطات مستقیم و غیرمستقیم آن‌ها شناسایی می‌شوند.',
  'copy.watchlistCaption':
    'نام‌ها با فهرست‌های تحریم، نهادهای ممنوع و فهرست‌های نظارتی جهانی تطبیق داده می‌شوند.',
  'copy.heroDescription': '؛ گردآوری خودکار اطلاعات، شناسایی ریسک و تهیه گزارش، همه در یک سامانه.',
  'copy.age': 'سن:',
  'copy.nationality': 'ملیت:',
  'copy.job': 'شغل:',
  'copy.audience': '؛ راهکاری مناسب برای',
  'copy.ownerActivation': '؛ پس از ورود مالک و فعال شدن حساب، به شما اطلاع داده می‌شود.',
  'copy.officerActivation': '؛ حساب کارشناس پس از ورود از طریق دعوت‌نامه فعال می‌شود.',
  'copy.findingInstructions': '؛ هر یافته را همراه با دلیل تأیید یا رد کنید.',
  'copy.source': 'منبع:',
  'copy.fatfGreyList': 'فهرست خاکستری FATF',
  'copy.ofacMatch': 'تطبیق نام در فهرست OFAC',
  'copy.interpolNotice': 'اعلان قرمز اینترپل',
  'copy.euSanctions': 'درج در فهرست تحریم اتحادیه اروپا',
};
